import React, { useState, useEffect } from "react";
import { CATEGORIES } from "../data/mockData";
import { generateId } from "../utils/helpers";
import { useApp } from "../context/AppContext";

export default function TransactionModal({ transaction, onClose }) {
  const { state, dispatch } = useApp();
  const dark = state.theme === "dark";
  const isEdit = !!transaction;

  const [form, setForm] = useState({
    description: "", amount: "", category: "Food", type: "expense", date: new Date().toISOString().slice(0, 10),
    ...(transaction || {}),
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const validate = () => {
    const e = {};
    if (!form.description.trim()) e.description = "Required";
    if (!form.amount || isNaN(form.amount) || +form.amount <= 0) e.amount = "Must be > 0";
    if (!form.date) e.date = "Required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    const tx = { ...form, amount: parseFloat(form.amount), id: form.id || generateId() };
    dispatch({ type: isEdit ? "EDIT_TRANSACTION" : "ADD_TRANSACTION", payload: tx });
    onClose();
  };

  const input = (label, field, type = "text", options = null) => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: "block", marginBottom: 6, color: dark ? "#94a3b8" : "#64748b", fontSize: 13, fontWeight: 500 }}>{label}</label>
      {options ? (
        <select value={form[field]} 
        onChange={(e) => setForm({ ...form, [field]: e.target.value })}
          style={{ width: "100%", padding: 
          "10px 12px", borderRadius: 8, border: `1px solid ${errors[field] ? "#f43f5e" : dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.15)"}`, background: dark ? "#0f172a" : "#fff", color: dark ? "#f1f5f9" : "#0f172a", fontSize: 14, outline: "none" }}>
          {options.map((o) =>
             <option key={o.value || o} value={o.value || o}>{o.label || o}</option>)}
        </select>
      ) : (
        <input type={type} value={form[field]} onChange={(e) => setForm({ ...form, [field]: e.target.value })}
          style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: `1px solid ${errors[field] ? "#f43f5e" : dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.15)"}`, background: dark ? "rgba(255,255,255,0.06)" : "#fff", color: dark ? "#f1f5f9" : "#0f172a", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
      )}
      {errors[field] && <p style={{ margin: "4px 0 0", color: "#f43f5e", fontSize: 12 }}>{errors[field]}</p>}
    </div>
  );

  //transaction add 
  return (
    <div style={{ position: "fixed",
       inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={(e) => {
         if (e.target === e.currentTarget) onClose(); }}>
      <div style={{
        background: dark ? "#0d1324" : "#fff", borderRadius: 16, width: "100%", maxWidth: 440,
        border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.1)"}`,
        boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
        animation: "modalIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
      }}>
        <div style={{ padding: "20px 24px",
           borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)"}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, color: dark ? "#f1f5f9" :
             "#0f172a", fontSize: 18, fontWeight: 700 }}>
            {isEdit ? "Edit Transaction" : "New Transaction"}
          </h2>
          <button onClick={onClose}
           style={{ background: "none", border: "none", cursor: "pointer", color: dark ? "#475569" : "#94a3b8", fontSize: 20, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 24 }}>
          {input("Description", "description")}
          <div style={{ display: "grid", gridTemplateColumns: 
            "1fr 1fr", gap: 16 }}>
            <div>{input("Amount ($)", "amount", "number")}</div>
            <div>{input("Date", "date", "date")}</div>
          </div>
          {input("Category", "category", "select", CATEGORIES)}
          {input("Type", "type", "select", [{ value: "income", label: 
            " Income" }, { value: "expense", label: " Expense" }])}
          <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
            <button onClick={onClose} style={{ flex: 1, padding: "12px",
               borderRadius: 10, border: `1px solid ${dark ? "rgba(255,255,255,0.1)" :
                "rgba(0,0,0,0.15)"}`, background: "transparent", color: dark ? "#94a3b8" : "#64748b", fontSize: 14, cursor: "pointer", fontWeight: 500 }}>Cancel</button>
            <button onClick={handleSubmit} style={{ flex: 1, padding: "12px", borderRadius: 10, border: "none", background: "linear-gradient(135deg, #6366f1, #4f46e5)", color: "#fff", fontSize: 14, cursor: "pointer", fontWeight: 600 }}>{isEdit ? "Save Changes" : "Add Transaction"}</button>
          </div>
        </div>
      </div>
      <style>{`@keyframes modalIn { from { opacity: 0; transform: scale(0.9) translateY(20px); } to { opacity: 1; transform: scale(1) translateY(0); } }`}</style>
    </div>
  );
}
